import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_CREDIT_LISTING,
} from "./actionTypes.js";

import {
    getCreditListingSuccess,
    getCreditListingFail,
} from "./actions.js";

import { creditListingApi } from "./creditApi.js";

function* fetchCreditListing({ payload }) {
    try {
        const response = yield call(creditListingApi, payload);
        yield put(getCreditListingSuccess(response));
    } catch (error) {
        yield put(getCreditListingFail(error));
    }
}

function* CreditSaga() {
    yield takeEvery(GET_CREDIT_LISTING, fetchCreditListing);
}

export default CreditSaga